import React, { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  es: {
    // Navigation
    'nav.domains': 'Mis Dominios',
    'nav.messaging': 'CM/CC/CV',
    'nav.wallet': 'Wallet',
    'nav.economy': 'Mi Economia',
    'nav.inventory': 'Mi Inventario',
    'nav.marketplace': 'Marketplace',
    'nav.cualinmarket': 'CUALINMARKET',
    'nav.tasks': 'Mis Tareas',
    'nav.celula': 'Mi Celula',
    'nav.pago_movil': 'Pago Movil',
    'nav.automations': 'Automatizaciones',
    'nav.blockchain': 'Blockchain',
    'nav.map': 'Mapa',
    'nav.kyc': 'KYC',
    'nav.transport': 'Transporte',
    'nav.transactions': 'Transacciones',
    'nav.escrow': 'Comercio P2P',
    'nav.smart_escrow': 'Smart Contracts',
    'nav.payouts': 'Payouts',
    'nav.disputes': 'Disputas',
    'nav.analytics': 'Analytics',
    'nav.logs': 'Bitacora',
    'nav.assistant': 'Asistente',
    'nav.jarvis': 'J.A.R.V.I.S.',
    'nav.admin': 'Admin',
    // Auth
    'auth.login': 'Iniciar Sesion',
    'auth.register': 'Registrarse',
    'auth.email': 'Correo electronico',
    'auth.password': 'Contrasena',
    'auth.name': 'Nombre completo',
    'auth.submit_login': 'Entrar',
    'auth.submit_register': 'Crear cuenta',
    'auth.switch_register': 'Crear una cuenta',
    'auth.switch_login': 'Ya tengo cuenta',
    'auth.logout': 'Salir',
    // Common
    'common.loading': 'Cargando...',
    'common.search': 'Buscar',
    'common.save': 'Guardar',
    'common.cancel': 'Cancelar',
    'common.create': 'Crear',
    'common.delete': 'Eliminar',
    'common.confirm': 'Confirmar',
    'common.back': 'Volver',
    'common.send': 'Enviar',
    'common.close': 'Cerrar',
    // Omnibox
    'omnibox.placeholder': 'Buscar en CUALAPP... dominios, items, usuarios, mercado',
    // Transport
    'transport.request_ride': 'Solicitar Viaje',
    'transport.popular_routes': 'Rutas Populares',
    'transport.surge_active': 'Tarifa dinamica activa',
    'transport.eta': 'Tiempo estimado',
    'transport.fare': 'Tarifa estimada',
    // Analytics
    'analytics.title': 'Dashboard de Analytics',
    'analytics.velocity': 'Velocidad Economica',
    'analytics.activity': 'Actividad por Dia',
    'analytics.modules': 'Modulos Mas Usados',
    'analytics.jurisdictions': 'Usuarios por Jurisdiccion',
    // Disputes
    'disputes.title': 'Mediacion & Disputas',
    'disputes.open': 'Abrir Disputa',
    'disputes.evidence': 'Evidencia',
    'disputes.resolve': 'Resolver',
    // Settings
    'settings.language': 'Idioma',
  },

  en: {
    'nav.domains': 'My Domains',
    'nav.messaging': 'CM/CC/CV',
    'nav.wallet': 'Wallet',
    'nav.economy': 'My Economy',
    'nav.inventory': 'My Inventory',
    'nav.marketplace': 'Marketplace',
    'nav.cualinmarket': 'CUALINMARKET',
    'nav.tasks': 'My Tasks',
    'nav.celula': 'My Celula',
    'nav.pago_movil': 'Mobile Payment',
    'nav.automations': 'Automations',
    'nav.blockchain': 'Blockchain',
    'nav.map': 'Map',
    'nav.kyc': 'KYC',
    'nav.transport': 'Transport',
    'nav.transactions': 'Transactions',
    'nav.escrow': 'P2P Commerce',
    'nav.smart_escrow': 'Smart Contracts',
    'nav.payouts': 'Payouts',
    'nav.disputes': 'Disputes',
    'nav.analytics': 'Analytics',
    'nav.logs': 'Activity Log',
    'nav.assistant': 'Assistant',
    'nav.jarvis': 'J.A.R.V.I.S.',
    'nav.admin': 'Admin',
    'auth.login': 'Login',
    'auth.register': 'Register',
    'auth.email': 'Email address',
    'auth.password': 'Password',
    'auth.name': 'Full name',
    'auth.submit_login': 'Sign In',
    'auth.submit_register': 'Create Account',
    'auth.switch_register': 'Create an account',
    'auth.switch_login': 'I have an account',
    'auth.logout': 'Logout',
    'common.loading': 'Loading...',
    'common.search': 'Search',
    'common.save': 'Save',
    'common.cancel': 'Cancel',
    'common.create': 'Create',
    'common.delete': 'Delete',
    'common.confirm': 'Confirm',
    'common.back': 'Back',
    'common.send': 'Send',
    'common.close': 'Close',
    'omnibox.placeholder': 'Search CUALAPP... domains, items, users, market',
    'transport.request_ride': 'Request Ride',
    'transport.popular_routes': 'Popular Routes',
    'transport.surge_active': 'Surge pricing active',
    'transport.eta': 'Estimated time',
    'transport.fare': 'Estimated fare',
    'analytics.title': 'Analytics Dashboard',
    'analytics.velocity': 'Economic Velocity',
    'analytics.activity': 'Daily Activity',
    'analytics.modules': 'Most Used Modules',
    'analytics.jurisdictions': 'Users by Jurisdiction',
    'disputes.title': 'Mediation & Disputes',
    'disputes.open': 'Open Dispute',
    'disputes.evidence': 'Evidence',
    'disputes.resolve': 'Resolve',
    'settings.language': 'Language',
  },

  pt: {
    'nav.domains': 'Meus Dominios',
    'nav.messaging': 'CM/CC/CV',
    'nav.wallet': 'Carteira',
    'nav.economy': 'Minha Economia',
    'nav.inventory': 'Meu Inventario',
    'nav.marketplace': 'Marketplace',
    'nav.cualinmarket': 'CUALINMARKET',
    'nav.tasks': 'Minhas Tarefas',
    'nav.celula': 'Minha Celula',
    'nav.pago_movil': 'Pagamento Movel',
    'nav.automations': 'Automacoes',
    'nav.blockchain': 'Blockchain',
    'nav.map': 'Mapa',
    'nav.kyc': 'KYC',
    'nav.transport': 'Transporte',
    'nav.transactions': 'Transacoes',
    'nav.escrow': 'Comercio P2P',
    'nav.smart_escrow': 'Smart Contracts',
    'nav.payouts': 'Pagamentos',
    'nav.disputes': 'Disputas',
    'nav.analytics': 'Analytics',
    'nav.logs': 'Registro',
    'nav.assistant': 'Assistente',
    'nav.jarvis': 'J.A.R.V.I.S.',
    'nav.admin': 'Admin',
    'auth.login': 'Entrar',
    'auth.register': 'Registrar-se',
    'auth.email': 'Endereco de email',
    'auth.password': 'Senha',
    'auth.name': 'Nome completo',
    'auth.submit_login': 'Entrar',
    'auth.submit_register': 'Criar Conta',
    'auth.switch_register': 'Criar uma conta',
    'auth.switch_login': 'Ja tenho conta',
    'auth.logout': 'Sair',
    'common.loading': 'Carregando...',
    'common.search': 'Buscar',
    'common.save': 'Salvar',
    'common.cancel': 'Cancelar',
    'common.create': 'Criar',
    'common.delete': 'Excluir',
    'common.confirm': 'Confirmar',
    'common.back': 'Voltar',
    'common.send': 'Enviar',
    'common.close': 'Fechar',
    'omnibox.placeholder': 'Buscar CUALAPP... dominios, itens, usuarios, mercado',
    'transport.request_ride': 'Solicitar Viagem',
    'transport.popular_routes': 'Rotas Populares',
    'transport.surge_active': 'Tarifa dinamica ativa',
    'transport.eta': 'Tempo estimado',
    'transport.fare': 'Tarifa estimada',
    'analytics.title': 'Painel de Analytics',
    'analytics.velocity': 'Velocidade Economica',
    'analytics.activity': 'Atividade Diaria',
    'analytics.modules': 'Modulos Mais Usados',
    'analytics.jurisdictions': 'Usuarios por Jurisdicao',
    'disputes.title': 'Mediacao & Disputas',
    'disputes.open': 'Abrir Disputa',
    'disputes.evidence': 'Evidencia',
    'disputes.resolve': 'Resolver',
    'settings.language': 'Idioma',
  }
};

const LANG_LABELS = { es: 'Espanol', en: 'English', pt: 'Portugues' };
const LANG_FLAGS = { es: '🇪🇸', en: '🇺🇸', pt: '🇧🇷' };

const I18nContext = createContext();

export const I18nProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem('cualapp_lang') || 'es');

  useEffect(() => { localStorage.setItem('cualapp_lang', lang); }, [lang]);

  const t = (key) => translations[lang]?.[key] || translations.es[key] || key;

  return (
    <I18nContext.Provider value={{ lang, setLang, t, LANG_LABELS, LANG_FLAGS }}>
      {children}
    </I18nContext.Provider>
  );
};

export const useI18n = () => useContext(I18nContext);

export const LanguageSelector = () => {
  const { lang, setLang, LANG_LABELS, LANG_FLAGS } = useI18n();

  return (
    <div className="flex gap-1" data-testid="language-selector">
      {Object.entries(LANG_LABELS).map(([code, label]) => (
        <button key={code} onClick={() => setLang(code)} data-testid={`lang-${code}`}
          className={`px-2.5 py-1 rounded-lg text-xs font-medium transition-colors ${
            lang === code ? 'bg-indigo-600 text-white' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
          }`}>
          {LANG_FLAGS[code]} {label}
        </button>
      ))}
    </div>
  );
};
